import { render, staticRenderFns } from "./upload_video.vue?vue&type=template&id=31645ebf&scoped=true"
import script from "./upload_video.vue?vue&type=script&lang=js"
export * from "./upload_video.vue?vue&type=script&lang=js"
import style0 from "./upload_video.vue?vue&type=style&index=0&id=31645ebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31645ebf",
  null
  
)

export default component.exports